module.exports = __webpack_public_path__ + "static/media/lichter_oben_on.10558c47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/png/food-store/lichter_oben_on.png
// module id = 508
// module chunks = 0